<template>
  <v-container>
    <v-card class="mx-auto">
      <v-card-title class="text-lg-h6">Checkout</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" md="8" sm="12" xs="12">
            <v-card-text v-for="i in pageCount(document)" :key="i" class="my-1">
              <pdf
                style="width: 100%"
                :src="`data:application/pdf;base64,${document}`"
                :page="i"
              />
            </v-card-text>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" md="4" sm="12" xs="12" class="px-3">
            <v-card tile flat>
              <div class="overline mt-1">Billing Summary</div>
              <v-divider />
              <v-simple-table class="mt-3" dense>
                <thead class="caption text-center">
                  <tr>
                    <th class="text-left">Item</th>
                    <th class="text-center">Qty</th>
                    <th class="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody class="caption">
                  <tr>
                    <td class="text-left caption">Units</td>
                    <td class="text-center caption">
                      {{ units.unitsTaken.length }}
                    </td>
                    <td class="text-right caption">
                      {{ totals.taken | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left caption">Exemptions</td>
                    <td class="text-center caption">
                      {{ units.unitsExempted.length }}
                    </td>
                    <td class="text-right caption">
                      {{ totals.exempted | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left caption">Other Charges</td>
                    <td class="text-center caption">
                      {{ units.otherCharges.length }}
                    </td>
                    <td class="text-right caption">
                      {{ totals.charges | currency }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-divider class="mt-5" />

              <v-simple-table dense class="overline pa-2">
                <tr class="text-right">
                  <td>Total</td>
                  <td class="text-fontweight-bold">
                    {{
                      (totals.charges + totals.taken + totals.exempted)
                        | currency
                    }}
                  </td>
                </tr>
              </v-simple-table>
            </v-card>
            <v-divider class="my-3"></v-divider>
            <v-form v-model="isValid" ref="checkoutForm">
              <v-text-field
                placeholder="Enter Your Name"
                label="Name"
                persistent-placeholder
                prepend-inner-icon="person"
                dense
                v-model="name"
                clearable
                :rules="[rules.required]"
                outlined
              ></v-text-field>
              <vue-tel-input-vuetify
                required
                clearable
                placeholder="Enter Mpesa Phone Number"
                label="Phone Number"
                autofocus
                :inputOptions="{
                  showDialCode: true,
                  tabindex: 1,
                }"
                outlined
                dense
                v-model="phone"
                defaultCountry="KE"
                :onlyCountries="['KE', 'UG', 'TZ']"
                :rules="[rules.phone]"
              ></vue-tel-input-vuetify>
              <v-btn color="primary" class="mt-10" block @click="pay">
                <v-icon class="mx-2">money</v-icon>
                pay
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
import pdf from "vue-pdf";
import FileMixin from "../../dashboard/mixin/FileMixin";
export default {
  name: "CheckoutComponent",
  components: { pdf },
  mixins: [FileMixin],
  data: function () {
    return {
      totals: {},
      phone: "",
      name: "",
      isValid: false,
      units: {
        unitsTaken: [],
        unitsExempted: [],
        otherCharges: [],
      },
      rules: {
        phone: (v) =>
          /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(
            v,
          ) || "Phone No. Must be valid i.e +254712345678",
        required: (v) => !!v || "Field is required",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      const data = JSON.parse(atob(to.query.data));
      v.totals = data.totals;
      v.units = data.units;
      v.$store.dispatch(
        "Renewal/getRegistrationDocument",
        v.$route.params.regNo,
      );
    });
  },
  computed: {
    document() {
      return this.$store.getters["Renewal/registrationDocument"];
    },
  },
  methods: {
    pay() {
      if (!this.isValid) {
        this.$refs.checkoutForm.validate();
      } else {
        const options = {
          method: "POST",
          headers: {
            "content-type": "Application/json",
            "Access-Control-Allow-Origin": "*",
          },
          data: JSON.stringify({
            payerID: this.name,
            sourceDocumentNo: "123",
            providerID: "KISEB",
            description: "Reg",
            amount: "1",
            accountNo: this.phone,
          }),
          url: process.env.VUE_APP_PAYGATE_CHECKOUT_URL,
        };
        this.$store.commit("Dashboard/SET_LOADING", true);
        axios(options)
          .then((res) => {
            this.$store.commit("Dashboard/SET_LOADING", false);
            Event.$emit("ApiSuccess", res.data.data.CustomerMessage);
            this.$router.back();
          })
          .catch((error) => {
            this.$store.commit("Dashboard/SET_LOADING", false);
            Event.$emit("ApiError", error.response.data.message);
          });
      }
    },
  },
};
</script>
